import { createApp } from 'vue'
import { createStore } from 'vuex'
import { router } from './route';
import { Apps } from './modules/App';
import App from './App.vue'
import en from './locales/en.json'
import zhHans from './locales/zh_Hans.json'
import zhHant from './locales/zh_Hant.json'
import { createI18n } from 'vue-i18n';

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'zh_Hans', // 默认语言
  fallbackLocale: 'en', // 回退语言
  globalInjection: true, // 全局注入 $t 函数
  messages: {
    en,
    'zh_Hans': zhHans,
    'zh_Hant': zhHant
  }
})
const app=createApp(App)
const store = createStore({
    modules: {
        Apps,
    }
})
app.use(i18n).use(router).use(store)
app.mount("#app")
export {store, router}